import { DELAY, MAX_WAIT } from './constants';
import type { Options } from './types';

export const getArguments = (delayOrOptions?: number | Options): [number, Options] => {
  if (typeof delayOrOptions === 'undefined' || typeof delayOrOptions === 'number') {
    return [delayOrOptions ?? DELAY, { maxWait: MAX_WAIT }];
  }
  return [delayOrOptions.delay ?? DELAY, delayOrOptions];
};
